import { Field, InputType, ObjectType } from 'type-graphql'
import { modelOptions, Prop } from '@typegoose/typegoose'

@ObjectType()
@InputType('ShippingBillToInput')
@modelOptions({ schemaOptions: { timestamps: true } })
export class ShippingBillTo {
  @Field(() => String)
  @Prop({ type: String })
  account: string

  @Field(() => String)
  @Prop({ type: String })
  countryCode: string

  @Field(() => String)
  @Prop({ type: String })
  postalCode: string

  @Field(() => Boolean)
  @Prop({ type: Boolean })
  isBillToCustomer: boolean
}
